const getBrowseConfig = apiClient => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/browse`;
  return apiClient.get(route);
};

export { getBrowseConfig };
